import React, { useState } from "react";
import { Button } from "../design/button";
import EmploymentInfoDialog from "./Dialogs/EmploymentInfoDialog/EmploymentInfoDialog";
import { EmploymentInfo } from "../models/EmploymentInfo";
import { Participant } from "../models/Participant";

interface Props {
  participantId: Participant["_id"];
  employmentInfo?: EmploymentInfo;
}

const EmploymentInfoButton: React.FC<Props> = ({
  participantId,
  employmentInfo,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Button type="button" onClick={() => setIsOpen(true)}>
        {employmentInfo ? "Edit" : "Add Employment"}
      </Button>
      <EmploymentInfoDialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        employmentInfo={employmentInfo}
        participantId={participantId}
      />
    </>
  );
};

export default EmploymentInfoButton;
